import { render, staticRenderFns } from "./NextMoveResult.vue?vue&type=template&id=02356121&scoped=true&"
import script from "./NextMoveResult.vue?vue&type=script&lang=ts&"
export * from "./NextMoveResult.vue?vue&type=script&lang=ts&"
import style0 from "./NextMoveResult.vue?vue&type=style&index=0&id=02356121&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02356121",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VRow})
